import { render, staticRenderFns } from "./IssueView.vue?vue&type=template&id=47aa676c&scoped=true&"
import script from "./IssueView.vue?vue&type=script&lang=js&"
export * from "./IssueView.vue?vue&type=script&lang=js&"
import style0 from "./IssueView.vue?vue&type=style&index=0&id=47aa676c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47aa676c",
  null
  
)

export default component.exports